import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IReturnDecision } from '../../interfaces/return-list/return-decision.interface';
import { ITableServerFilter } from 'src/app/common/interfaces/table/table-server-filter.inteface';
import { ITableServerResponseFilter } from 'src/app/common/interfaces/table/table-server-filter-response.interface';
import { IWebMessage } from 'src/app/common/interfaces/webmessage-interface';
import { IReturnList } from '../../interfaces/return-list/return-list.interface';
import { lastValueFrom } from 'rxjs';
import { AbstractRtpReturnListService } from '../abstraction/abstract.return-request-list.service';

@Injectable({
  providedIn: 'root',
})
export class MockReturnRequestListService extends AbstractRtpReturnListService {
  private tableFilterJson = 'assets/mocks/rtp/returnlist/tableFilter.json';
  private returnListJson = 'assets/mocks/rtp/returnlist/returnList.json';
  private reasonDenyListJson = 'assets/mocks/rtp/returnlist/reasonDenyList.json';
  private alternatePaymentChannelJson = 'assets/mocks/rtp/returnlist/alternatePaymentChannel.json';
  private getByIdPendingJson = 'assets/mocks/rtp/returnlist/getById_Pending.json';
  private getByIdApprovedJson = 'assets/mocks/rtp/returnlist/getById_Approved.json';
  private getByIdDeniedJson = 'assets/mocks/rtp/returnlist/getById_Denied.json';
  private returnDecision = 'assets/mocks/rtp/returnlist/returnDecision.json';

  constructor(private http: HttpClient) {
    super();
  }

  tableFilter(filter: ITableServerFilter): Promise<ITableServerResponseFilter | undefined> {
    return lastValueFrom(this.http.get<ITableServerResponseFilter>(this.tableFilterJson));
  }

  tableExportCSV(filter: ITableServerFilter): Promise<Blob | undefined> {
    throw new Error('Method not implemented.');
  }

  tableExportExcel(filter: ITableServerFilter): Promise<Blob | undefined> {
    throw new Error('Method not implemented.');
  }

  tableFilterSingleRecordById(messageId: string): Promise<IReturnList | undefined> {
    throw new Error('Method not implemented.');
  }

  returnRequestList(): Promise<any> {
    return lastValueFrom(this.http.get<ITableServerResponseFilter>(this.returnListJson));
  }

  async getById(rtpUniqueMessageId: string): Promise<any> {
    const list = await this.http.get<ITableServerResponseFilter>(this.tableFilterJson).toPromise();
    const original = list?.queryable.find(x => x.rtpUniqueMessageId == rtpUniqueMessageId);

    if (original.returnRequestStatus == 'Return Denied')
      return lastValueFrom(this.http.get<ITableServerResponseFilter>(this.getByIdDeniedJson));
    if (original.returnRequestStatus == 'Return Approved')
      return lastValueFrom(this.http.get<ITableServerResponseFilter>(this.getByIdApprovedJson));
    if (original.returnRequestStatus == 'Decision Pending')
      return lastValueFrom(this.http.get<ITableServerResponseFilter>(this.getByIdPendingJson));
  }

  reasonDenyList(): Promise<any> {
    return lastValueFrom(this.http.get<ITableServerResponseFilter>(this.reasonDenyListJson));
  }

  returnStatusList(): Promise<any> {
    return lastValueFrom(this.http.get<ITableServerResponseFilter>(this.returnListJson));
  }

  paymentChannelList(): Promise<any> {
    return lastValueFrom(
      this.http.get<ITableServerResponseFilter>(this.alternatePaymentChannelJson)
    );
  }

  decisionSubmit(decision: IReturnDecision): Promise<IWebMessage | undefined> {
    return lastValueFrom(this.http.get<IWebMessage>(this.returnDecision));
  }
}
